import React, {useState} from 'react';

const VehicleIdPart = (props) => {

    const updateVin = (evt) =>{
        props.onUpdate(props.id, "vin", evt.target.value);
    };
    const updateBookingNum = (evt) =>{
        props.onUpdate(props.id, "bookingNum", evt.target.value);
    };

    return (
        <div className="row">
            <div className="col-6">
                <label className="control-label">Vehicle VIN #</label>
                <input required type="text" name="vehicle_vins" className="form-control"
                    defaultValue={props.vin} onChange={(evt) => updateVin(evt)}
                    maxLength={50}/>                    
            </div>
            <div className="col-6">
                <label className="control-label">Vehicle Booking #</label>
                <input required type="text" name="vehicle_bookingNumbers" className="form-control"
                    defaultValue={props.bookingNum} onChange={(evt) => updateBookingNum(evt)}
                    maxLength={100}/>
            </div>       
        </div>
    );
}

export { VehicleIdPart }